import {
  IconMetroMsk16,
  IconMetroSpb16,
  IconMetroEkb16,
  IconMetroKzn16,
  IconMetroNovosib16,
  IconMetroSam16,
  IconMetroNN16,
} from '@cian/ui-kit/icons';
import * as React from 'react';

import * as styles from './styles.css';
import { EUndergroundType } from '../../../../types/newbuildingHeader';

interface IUndergroundIconProps {
  lineColor: string;
  type: EUndergroundType;
}

export const UndergroundIcon: React.FC<IUndergroundIconProps> = ({ lineColor, type }) => {
  const color = React.useMemo(() => `#${lineColor}`, [lineColor]);

  const icon: React.ReactNode = React.useMemo(() => {
    switch (type) {
      case EUndergroundType.Mow:
        return <IconMetroMsk16 color="current_color" />;
      case EUndergroundType.Spb:
        return <IconMetroSpb16 color="current_color" />;
      case EUndergroundType.Ekb:
        return <IconMetroEkb16 color="current_color" />;
      case EUndergroundType.Kzn:
        return <IconMetroKzn16 color="current_color" />;
      case EUndergroundType.Nsk:
        return <IconMetroNovosib16 color="current_color" />;
      case EUndergroundType.Smr:
        return <IconMetroSam16 color="current_color" />;
      case EUndergroundType.NN: // Нижний Новгород
        return <IconMetroNN16 color="current_color" />;
      default:
        return <IconMetroMsk16 color="current_color" />;
    }
  }, [type]);

  return (
    <div className={styles['cont']} style={{ color }}>
      {icon}
    </div>
  );
};
